export default __webpack_public_path__ + "static/media/offc-mob1.1830a0fc.png";